import { Link } from "react-router-dom";
import styles from "./error.module.css";
import Button from "@mui/material/Button";
import { motion } from "framer-motion";

function Error() {
    return (
        <div className={styles.errorContainer}>
            <motion.div>
                <h1 className={styles.errorTitle}>404 - Seite nicht gefunden</h1>
                <p className={styles.errorMessage}>Uups! Die gesuchte Seite existiert nicht.</p>
                <Link to="/">
                    <Button className={styles.errorButton}>Zur Startseite...</Button>
                </Link>
            </motion.div>
        </div>
    );
}

export default Error;